module.exports = __webpack_public_path__ + "img/9b990a2c84246c40289d5132aff7909d.png";